
export class DatabaseConstants {
    static databaseTypes = [
        {
            displayName: 'MongoDB',
            image: './assets/img/partnerOnboarding/mongoDB.png',
            value: 'mongodb',
            provider: 'apiplatform',
            selected: true,
            disabled: false,
            description: 'Document-oriented NoSQL database'
        },
        // {
        //     displayName: 'DynamoDB',
        //     image: './assets/img/partnerOnboarding/dynamoDB.png',
        //     value: 'dynamodb',
        //     provider: 'apiplatform',
        //     selected: false,
        //     disabled: false,
        //     description: 'Managed NoSQL database service'
        // },
        {
            displayName: 'PostgreSQL',
            image: './assets/img/partnerOnboarding/postgreySQL.png',
            value: 'postgresql',
            provider: 'apiplatform',
            selected: false,
            disabled: false,
            description: 'Open source object-relational database system'
        },
        {
            displayName: 'MySQL',
            image: './assets/img/partnerOnboarding/mySQL.png',
            value: 'mysql',
            provider: 'apiplatform',
            selected: false,
            disabled: false,
            description: 'Open source relational database management system'
        },
        {
            displayName: 'MS SQL Server',
            image: './assets/img/partnerOnboarding/msSQL.jpg',
            value: 'sqlserver',
            provider: 'apiplatform',
            selected: false,
            disabled: false,
            description: 'Relational database management system developed by Microsoft'
        },
        {
            displayName: 'Aurora-MySQL',
            image: './assets/img/partnerOnboarding/aurora.png',
            value: 'aurora-mysql',
            provider: 'apiplatform',
            selected: false,
            disabled: false,
            description: 'MySQL-compatible relational database engine'
        },
        {
            displayName: 'CosmosDB',
            image: './assets/img/partnerOnboarding/cosmosDB.png',
            value: 'cosmosdb', provider: 'apiplatform',
            selected: false,
            disabled: false,
            description: 'Distributed NoSQL database service'
        },
        {
            displayName: 'AuroraDB-PostgreSQL',
            image: './assets/img/partnerOnboarding/aurora.png',
            value: 'aurora-postgresql',
            provider: 'apiplatform',
            selected: false,
            disabled: false,
            description: 'PostgreSQL-compatible relational database engine'
        },
        // {
        //     displayName: 'Snowflake',
        //     image: './assets/img/partnerOnboarding/snowflake.png',
        //     value: 'snowflake',
        //     provider: 'apiplatform',
        //     selected: false,
        //     disabled: false,
        //     description: 'Cloud-based data warehousing and analytics platform'
        // },
        // {
        //     displayName: 'I want to use my Database',
        //     value: 'private',
        //     provider: 'external',
        //     selected: false,
        //     disabled: false,
        //     config: {},
        //     description: 'Use a custom database that is not provided by the platform'
        // }
    ];
}
